import axios, { AxiosRequestConfig } from 'axios'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { getJWT } from 'src/helper/localStore/getJWT'
import { EmailHistoryParamsDTO, EmailHistoryOutputDTO } from './emailHistoryDTO'

class EmailHistoryServices {
  async getAllByParams(params: EmailHistoryParamsDTO): Promise<EmailHistoryOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      const res = await axios.get(
        `${process.env.REACT_APP_URL_NOTIFICATION}/notification/email-history/filter/`,
        config
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getById(id: number): Promise<EmailHistoryOutputDTO> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_NOTIFICATION}/notification/email-history/${id}/`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const emailHistoryServices = new EmailHistoryServices()
